// 系统管理
export default [
  {
    path: "/system",
    meta: { title: "系统管理" },
    component: () => import("../views/system/index"),
    children: [
      {
        path: "/system/user",
        name: "sysuser",
        meta: { title: "用户管理", isMenu: true },
        component: () => import("../views/system/user"),
      },
      {
        path: "/system/role",
        name: "sysrole",
        meta: { title: "角色管理", isMenu: true },
        component: () => import("../views/system/role"),
      },
      {
        path: "/system/menu",
        name: "sysmenu",
        meta: { title: "菜单管理", isMenu: true },
        component: () => import("../views/system/menu"),
      },
      {
        path: "/system/role/detail/associatedUsers",
        name: "associatedUsers",
        meta: { title: "关联用户" },
        component: () => import("../views/system/detail/associatedUsers"),
      },
    ],
  },
]
